import { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { HEADER_PHONE, NAV_LINKS } from '@/constants/navigation'
import { ROUTES } from '@/constants/routes'
import { cn } from '@/utils/cn'
import './Header.css'

const SCROLL_THRESHOLD = 24

function isNavLinkActive(to: string, pathname: string, hash: string): boolean {
  if (to.includes('#')) {
    const [path, linkHash] = to.split('#')
    const targetPath = path || '/'
    return pathname === targetPath && hash === `#${linkHash}`
  }

  return pathname === to
}

function BurgerIcon() {
  return (
    <span className="header__burger-icon" aria-hidden="true">
      <span className="header__burger-line" />
      <span className="header__burger-line" />
      <span className="header__burger-line" />
    </span>
  )
}

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const update = () => {
      setIsScrolled(window.scrollY > SCROLL_THRESHOLD)
    }

    update()
    window.addEventListener('scroll', update, { passive: true })

    return () => window.removeEventListener('scroll', update)
  }, [])

  // Close the mobile menu on navigation and on Escape
  useEffect(() => {
    setIsMenuOpen(false)
  }, [location.pathname, location.hash])

  useEffect(() => {
    if (!isMenuOpen) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [isMenuOpen])

  return (
    <header
      className={cn('header', isScrolled && 'header--scrolled', isMenuOpen && 'header--open')}
    >
      <div className="header__bar">
        <div className="header__inner">
        <NavLink to={ROUTES.HOME} className="header__logo" end>
          <img src="/logo.svg" alt="MetaMarket" className="header__logo-image" />
        </NavLink>

        <button
          type="button"
          className="header__burger"
          aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
          aria-expanded={isMenuOpen}
          aria-controls="header-menu"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <BurgerIcon />
        </button>

        <div id="header-menu" className="header__menu">
        <div className="header__menu-inner">
        <a href={`tel:${HEADER_PHONE.replace(/\D/g, '')}`} className="header__phone">
          <img src="/icons/phone.svg" alt="" className="header__phone-icon" />
          <span>{HEADER_PHONE}</span>
        </a>

        <nav className="header__nav" aria-label="Основное меню">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={() =>
                isNavLinkActive(link.to, location.pathname, location.hash)
                  ? 'header__link header__link--active'
                  : 'header__link'
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        </div>
        </div>
        </div>
      </div>
    </header>
  )
}
